import { Accordion, AccordionSummary, Divider, OutlinedInput, Button, FormLabel, RadioGroup, FormControlLabel, Radio, Typography, Card, FormGroup, Switch } from '@mui/material';
import { useContext, useState } from 'react';
import { Label } from './style/SingleNotificationStyle';
import { UserContext } from '../../context/UserContext';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTranslation } from 'react-i18next';
import AttToken from '../../helpers/attToken';
import { Stack } from '@mui/material';
import { IoFilter } from "react-icons/io5";
import { RxReset } from "react-icons/rx";
import { ticketStatusType, TicketsContext } from '../../context/TickestsContext';
import '@mui/x-date-pickers/themeAugmentation';
import GetFilters from '../../service/GetFilters';
import AutocompleteWithApi from '../Autocomplete/AutocompleteWithApi';
import DatePickerFim from '../DatePicker/DatePickerFim';
import DatePickerInicio from '../DatePicker/DatePickerInicio';
import { trackEventMatomo } from '../../helpers/matomo';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useQuery } from '@tanstack/react-query';
import { userBackObj } from '../Users/ListaUsuarios';

type props = {
  isLoading: boolean,
  setIndex: Function,
  setDisabled: Function,
  setCurrentPage: Function
  setReset: Function
};

const ticketService = new GetFilters();

export default function TicketsFilters({
  setReset,
  isLoading,
  setIndex,
  setDisabled,
  setCurrentPage
}: props) {

  const { t } = useTranslation('translation');
  const { userData, hierarchyLabel } = useContext(UserContext);
  const {
    ordem,
    setOrdem,
    ordenarPor,
    setOrdenarPor,
    userEmissor,
    setUserEmissor,
    modelosNovos,
    setModelosNovos,
    modelos,
    setModelos,
    inicioRangeDe,
    setInicioRangeDe,
    inicioRangeAte,
    setInicioRangeAte,
    previsaoRangeDe,
    setPrevisaoRangeDe,
    previsaoRangeAte,
    setPrevisaoRangeAte,
    clientes,
    setClientes,
    locais,
    setLocais,
    conjuntos,
    setConjuntos,
    unidades,
    setUnidades,
    expirado,
    setExpirado,
    status,
    setStatus,
    setDefaultValues,
    responsavel,
    setResponsavel,
    exibeDuplicados,
    setExibeDuplicados
  } = useContext(TicketsContext);

  const [openUser, setOpenUser] = useState<boolean>(false);
  const [openCliente, setOpenCliente] = useState<boolean>(false);
  const [openLocal, setOpenLocal] = useState<boolean>(false);
  const [openConjunto, setOpenConjunto] = useState<boolean>(false);
  const [openUnidade, setOpenUnidade] = useState<boolean>(false);
  const [openChamadoLegado, setOpenChamadoLegado] = useState<boolean>(false);
  const [openChamado, setOpenChamado] = useState<boolean>(false);
  const [filtersToShow, setFilterToShow] = useState({
    dataLimite: false,
    duplicadosExpirados: false,
    usuarios: false,
    chamados: false,
    hierarquia: false,
  });

  const { data: usersData, isLoading: isLoadingUsers, isFetching: isFetchingUsers } = useQuery({
    queryKey: ['GET_USERS', openUser],
    queryFn: async () => {
      const token = await AttToken();
      if (token) {
        const response = await ticketService.getUsuarios(token, true);
        if (!response.users) throw new Error(t('notifications.ticketsFilters.errorFetchingUsers'));
        return response.users;
      }
    },
    enabled: openUser,
    retry: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000
  });

  const { data: chamadosData, isLoading: isLoadingChamados, isFetching: isFetchingChamados } = useQuery({
    queryKey: ['GET_CHAMADOS', openChamado],
    queryFn: async () => {
      const token = await AttToken();
      if (token) {
        const response = await ticketService.getChamados(token, false);
        if (!response.chamadosNovos) throw new Error(t('notifications.ticketsFilters.errorFetchingTickets'));
        return response.chamadosNovos;
      }
    },
    enabled: openChamado,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000
  });

  const { data: legadoData, isLoading: isLoadingLegado, isFetching: isFetchingLegado } = useQuery({
    queryKey: ['GET_CHAMADOS_LEGADO', openChamadoLegado],
    queryFn: async () => {
      const token = await AttToken();
      if (token) {
        const response = await ticketService.getChamados(token, true);
        if (!response.chamadosLegado) throw new Error(t('notifications.ticketsFilters.errorFetchingLegacyTickets'));
        return response.chamadosLegado;
      }
    },
    enabled: openChamadoLegado,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000
  });

  const { data: clientesData, isLoading: isLoadingClientes, isFetching: isFetchingClientes } = useQuery({
    queryKey: ['GET_CLIENTES', openCliente],
    queryFn: async () => {
      const token = await AttToken();
      if (token) {
        const response = await ticketService.getClientes(token);
        if (!response.clientes) throw new Error(t('notifications.ticketsFilters.errorFetchingClients'));
        return response.clientes;
      }
    },
    enabled: openCliente,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000
  });

  const { data: locaisData, isLoading: isLoadingLocais, isFetching: isFetchingLocais } = useQuery({
    queryKey: ['GET_LOCAIS', openLocal],
    queryFn: async () => {
      const token = await AttToken();
      if (token) {
        const response = await ticketService.getLocais(token);
        if (!response.locais) throw new Error(t('notifications.ticketsFilters.errorFetchingLocations'));
        return response.locais;
      }
    },
    enabled: openLocal,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000
  });

  const { data: conjuntosData, isLoading: isLoadingConjuntos, isFetching: isFetchingConjuuntos } = useQuery({
    queryKey: ['GET_CONJUNTO', openConjunto],
    queryFn: async () => {
      const token = await AttToken();
      if (token) {
        const response = await ticketService.getConjuntos(token);
        if (!response.conjuntos) throw new Error(t('notifications.ticketsFilters.errorFetchingSets'));
        return response.conjuntos;
      }
    },
    enabled: openConjunto,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000
  });

  const { data: unidadesData, isLoading: isLoadingUnidades, isFetching: isFetchingUnidades } = useQuery({
    queryKey: ['GET_UNIDADES', openUnidade],
    queryFn: async () => {
      const token = await AttToken();
      if (token) {
        const response = await ticketService.getUnidades(token);
        if (!response.unidades) throw new Error(t('notifications.ticketsFilters.errorFetchingUnits'));
        return response.unidades;
      }
    },
    enabled: openUnidade,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000
  });

  const verificarDatas = (inicioRangeDe: any, inicioRangeAte: any, previsaoRangeDe: any, previsaoRangeAte: any) => {
    const cadastroCompleto = inicioRangeDe && inicioRangeAte;
    const previsaoCompleta = previsaoRangeDe && previsaoRangeAte;
    return (cadastroCompleto && previsaoCompleta) || (cadastroCompleto && !previsaoRangeDe && !previsaoRangeAte) || (previsaoCompleta && !inicioRangeDe && !inicioRangeAte);
  };

  function handleExibeFiltros(value: boolean, filtro: string) {
    if (!value) {
      switch (filtro) {
        case 'dataLimite':
          setPrevisaoRangeDe(null);
          setPrevisaoRangeAte(null);
          break;
        case 'duplicadosExpirados':
          setExpirado('null');
          setExibeDuplicados(null);
          break;
        case 'usuarios':
          setUserEmissor(null);
          setResponsavel(null);
          break;
        case 'chamados':
          setModelosNovos(null);
          setModelos(null);
          break;
        case 'hierarquia':
          setClientes(null);
          setLocais(null);
          setConjuntos(null);
          setUnidades(null);
          break;
      }
    }
    setFilterToShow((prev) => ({ ...prev, [filtro]: value }));
  }

  return (
    <Stack width='100%' direction='column' spacing={2}>
      <Stack
        direction='row'
        width='100%'
        justifyContent='flex-end'
        alignItems='flex-start'
        spacing={1}>
        <Button
          disabled={isLoading || !verificarDatas(inicioRangeDe, inicioRangeAte, previsaoRangeDe, previsaoRangeAte)}
          endIcon={<IoFilter />}
          className='button is-success'
          variant='contained'
          type='submit'
          onClick={() => {
            setIndex([0]);
            setCurrentPage(0);
            setReset(Math.random());
            setDisabled(false);
            trackEventMatomo('filtro chamados', 'click', 'button', 'limpa filtros');
            const filter = {
              ordenarPor: ordenarPor,
              ordem: ordem,
              userEmissor: userEmissor,
              modelosNovos: modelosNovos,
              modelos: modelos,
              inicioRange: {
                de: inicioRangeDe && new Date(inicioRangeDe).setHours(0, 0, 0, 0),
                ate: inicioRangeAte && new Date(inicioRangeAte).setHours(23, 59, 59, 999)
              },
              previsaoRange: {
                de: previsaoRangeDe && new Date(previsaoRangeDe).setHours(0, 0, 0, 0),
                ate: previsaoRangeAte && new Date(previsaoRangeAte).setHours(23, 59, 59, 999)
              },
              clientes: clientes,
              locais: locais,
              conjuntos: conjuntos,
              unidades: unidades,
              expirado: expirado,
              status: status,
            };
            localStorage.setItem('filtros', JSON.stringify(filter));
          }}
        >
          {t('filter')}
        </Button>
        <Button
          endIcon={<RxReset />}
          className='button is-danger'
          variant='contained'
          type='submit'
          onClick={() => {
            setIndex([0]);
            setCurrentPage(0);
            setReset(Math.random());
            setDisabled(false);
            trackEventMatomo('filtro chamados', 'click', 'button', 'pesquisar');
            setDefaultValues();
            localStorage.removeItem('filtros');
          }}
        >
          {t('notifications.myTickets.cleanFilter')}
        </Button>
      </Stack>
      <Stack width='100%' direction={{ xs: 'column', lg: 'row' }} alignItems='flex-start' spacing={2}>
        <Accordion sx={{ padding: 1, width: '100%' }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ padding: 1 }}>
            <Typography textAlign='center' color='textDisabled' width='100%' variant='h5' fontWeight={700}>{t('table.title')}</Typography>
          </AccordionSummary>
          <Divider variant='middle' flexItem orientation='horizontal' />
          <Stack
            padding={2}
            direction="column"
            justifyContent="center"
            spacing={2}
          >
            <Stack direction='row' justifyContent='space-around' width='100%' spacing={2}>
              <Stack
                direction="column"
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={2}
              >
                <Label>{t('filterLabels.cadastro')}</Label>
                <DatePickerInicio maxDate={inicioRangeAte} inicio={inicioRangeDe} setInicio={setInicioRangeDe} label={t('filterLabels.inicio')} />
                <DatePickerFim inicio={inicioRangeDe} fim={inicioRangeAte} setFim={setInicioRangeAte} label={t('Reports.columns.end')} />
              </Stack>
              <Divider flexItem orientation='vertical' variant='middle' />
              <Stack direction='column' justifyContent='flex-start' alignItems='flex-end' spacing={2}>
                <Stack
                  width='100%'
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <FormControl fullWidth>
                    <FormLabel id="demo-radio-buttons-group-label">{t('notifications.myTickets.orderBy')}</FormLabel>
                    <RadioGroup
                      defaultValue={false}
                      name="radio-buttons-group"
                    >
                      <FormControlLabel
                        value={ordem}
                        control={<Radio
                          onClick={() => trackEventMatomo('filtro chamados', 'click', 'radio', 'seleciona valor')}
                          onChange={() => setOrdem(true)}
                          checked={ordem}
                          name="status"
                        />}
                        label={t('notifications.myTickets.ascendingDateOrder')} />
                      <FormControlLabel
                        value={ordem}
                        onClick={() => trackEventMatomo('filtro chamados', 'click', 'radio', 'seleciona valor')}
                        onChange={() => setOrdem(false)}
                        checked={!ordem}
                        name="status"
                        control={<Radio />}
                        label={t('notifications.myTickets.descendingDateOrder')} />
                    </RadioGroup>
                  </FormControl>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">{t('notifications.myTickets.orderBy')}</InputLabel>
                    <Select
                      defaultValue='inicio'
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={ordenarPor}
                      label={t('notifications.myTickets.orderBy')}
                      onChange={(event) => setOrdenarPor(event.target.value)}
                    >
                      <MenuItem value={'inicio'}>{t('notifications.myTickets.dateCreated')}</MenuItem>
                      <MenuItem value={'dataPrevisao'}>{t('notifications.myTickets.dueDate')}</MenuItem>
                    </Select>
                  </FormControl>
                </Stack>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">{t('notifications.ticketsFilters.status')}</InputLabel>
                  <Select
                    multiple
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={status?.filter((item) => item !== 'null') || []}
                    label={t('notifications.ticketsFilters.status')}
                    input={<OutlinedInput label={t('notifications.ticketsFilters.select')} />}
                    onChange={(event) => {
                      const value = event.target.value;
                      const nextStatus = typeof value === 'string'
                        ? value.split(',') as ticketStatusType[]
                        : value as ticketStatusType[];

                      setStatus(nextStatus.includes('all')
                        ? status?.includes('all')
                          ? nextStatus.filter((item) => item !== 'all')
                          : ['all']
                        : nextStatus);
                    }}
                  >
                    <MenuItem value="all">{t('notifications.ticketsFilters.showAll')}</MenuItem>
                    <MenuItem value="pendente">{t('notifications.requester.status.pendente')}</MenuItem>
                    <MenuItem value="aceito">{t('notifications.requester.status.aceito')}</MenuItem>
                    <MenuItem value="em_andamento">{t('notifications.requester.status.em_andamento')}</MenuItem>
                    <MenuItem value="concluido">{t('notifications.requester.status.concluido')}</MenuItem>
                    <MenuItem value="recusado">{t('notifications.requester.status.recusado')}</MenuItem>
                    <MenuItem value="cancelado">{t('notifications.requester.status.cancelado')}</MenuItem>
                    <MenuItem value="fechado">{t('notifications.requester.status.fechado')}</MenuItem>
                    <MenuItem value="fechadoCancelamento">{t('notifications.requester.status.fechadoCancelamento')}</MenuItem>
                    <MenuItem value="fechadoRecusa">{t('notifications.requester.status.fechadoRecusa')}</MenuItem>
                    <MenuItem value="reaberto">{t('notifications.requester.status.reaberto')}</MenuItem>
                    <MenuItem value="aprovado">{t('notifications.requester.status.aprovado')}</MenuItem>
                    <MenuItem value="fechadoDuplicidade">{t('notifications.myTickets.closedDueToDuplicity')}</MenuItem>
                  </Select>
                </FormControl>

              </Stack>
              <Divider flexItem orientation='vertical' variant='middle' />
              <Card sx={{ padding: 2 }}>
                <Label>{t('notifications.ticketsFilters.filterDisplaySelection')}</Label>
                <FormGroup onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleExibeFiltros(event.target.checked, event.target.value)}>
                  <FormControlLabel control={<Switch checked={filtersToShow.dataLimite} value='dataLimite' />} label={t('notifications.ticketsFilters.dueDate')} />
                  <FormControlLabel control={<Switch checked={filtersToShow.duplicadosExpirados} value='duplicadosExpirados' />} label={t('notifications.ticketsFilters.duplicatesExpired')} />
                  <FormControlLabel control={<Switch checked={filtersToShow.usuarios} value='usuarios' />} label={t('notifications.ticketsFilters.usersResponsibles')} />
                  <FormControlLabel control={<Switch checked={filtersToShow.chamados} value='chamados' />} label={t('notifications.ticketsFilters.legacyAndNewTickets')} />
                  <FormControlLabel control={<Switch checked={filtersToShow.hierarquia} value='hierarquia' />} label={t('notifications.ticketsFilters.hierarchy')} />
                </FormGroup>
              </Card>
            </Stack>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Stack
                flexDirection='column'
                justifyContent='flex-start'
                alignItems='flex-start'
                spacing={.8}
                width='100%'
              >
              </Stack>
            </Stack>
            <Divider variant='middle' flexItem orientation='horizontal' />
            <Stack
              spacing={2}
              direction="row"
              justifyContent='space-between'
              alignItems="center"
            >
              {filtersToShow.dataLimite && <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={2}
              >
                <Label>{t('filterLabels.limite')}</Label>
                <DatePickerInicio maxDate={previsaoRangeAte} inicio={previsaoRangeDe} setInicio={setPrevisaoRangeDe} label={t('filterLabels.inicio')} />
                <DatePickerFim inicio={previsaoRangeDe} fim={previsaoRangeAte} setFim={setPrevisaoRangeAte} label={t('Reports.columns.end')} />
              </Stack>}
              <Divider flexItem orientation='vertical' variant='middle' />
              {filtersToShow.duplicadosExpirados && <Stack direction='column' width='100%' spacing={2} alignItems='flex-start' justifyContent='flex-end'>
                <Label>{t('notifications.ticketsFilters.duplicatesExpirationSelection')}</Label>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">{t('filterLabels.mostrar')}</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    defaultValue={`${null}`}
                    value={`${exibeDuplicados}`}
                  label={t('filterLabels.mostrar')}
                    onChange={(eve) => setExibeDuplicados(JSON.parse(eve.target.value))}
                  >
                    <MenuItem value={"null"}>{t('filterLabels.todos')}</MenuItem>
                    <MenuItem value={"false"}>{t('filterLabels.notDouble')}</MenuItem>
                    <MenuItem value={"true"}>{t('filterLabels.double')}</MenuItem>
                  </Select>
                </FormControl>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">{t('notifications.ticketsFilters.expiration')}</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    defaultValue={typeof expirado !== 'boolean' ? 'null' : String(expirado)}
                    onClick={() => trackEventMatomo('filtro chamados', 'click', 'select', 'seleciona valor')}
                    onChange={(elem) => {
                      setExpirado(elem.target.value);
                    }}
                    label={t('notifications.ticketsFilters.expiration')}
                  >
                    <MenuItem value={`null`}>{t('notifications.ticketsFilters.showAll')}</MenuItem>
                    <MenuItem value={`true`}>{t('notifications.ticketsFilters.showOnlyExpiredTickets')}</MenuItem>
                    <MenuItem value={`false`}>{t('notifications.ticketsFilters.showOnlyTicketsWithinDeadline')}</MenuItem>
                  </Select>
                </FormControl>
              </Stack>}
            </Stack>
            {filtersToShow.usuarios && <>
              <Label className='filtersTitle'>{t('notifications.myTickets.byUsersResponsibles')}</Label>
              <Divider variant='middle' />
              <Stack direction='row' spacing={2} width='100%'>
                <AutocompleteWithApi
                  onChange={(values) => setUserEmissor(values)}
                  selectedValues={userEmissor ?? []}
                  setOpen={setOpenUser}
                  options={usersData?.map((user: userBackObj) => ({ label: user.nome, value: user.id })) ?? []}
                  loading={isLoadingUsers || isFetchingUsers}
                  textoVazio={t('notifications.ticketsFilters.noMatchingUsers')}
                  textoLoading={t('notifications.ticketsFilters.searchingUsers')}
                  textLabel={`${t('Reports.multipleUserSelect')}`}
                />
                <AutocompleteWithApi
                  onChange={(values) => setResponsavel(values)}
                  selectedValues={responsavel ?? []}
                  setOpen={setOpenUser}
                  options={[...new Set(usersData as { id: string, nome: string }[])]
                    ?.map((resp) => (
                      { label: resp.nome, value: resp.id })) ?? []}
                  loading={isLoadingUsers || isFetchingUsers}
                  textoVazio={t('notifications.ticketsFilters.noMatchingResponsibles')}
                  textoLoading={t('notifications.ticketsFilters.searchingResponsibles')}
                  textLabel={t('notifications.ticketsFilters.selectOneOrMoreResponsibles')}
                />
              </Stack>
            </>}
            {filtersToShow.chamados && <>
              <Label className='filtersTitle'>{t('notifications.ticketsFilters.byTickets')}</Label>
              <Divider />
              <Stack direction='row' spacing={2} width='100%'>
                {userData.migrado === true &&
                  <AutocompleteWithApi
                    onChange={(values) => setModelosNovos(values)}
                    selectedValues={modelosNovos ?? []}
                    setOpen={setOpenChamado}
                    options={
                      [...new Set(chamadosData as { id: string, nome: string }[])]
                        ?.map((novo) => (
                          { label: novo.nome, value: novo.id })) ?? []}
                    loading={isLoadingChamados || isFetchingChamados}
                    textoVazio={t('notifications.ticketsFilters.noMatchingTickets')}
                    textoLoading={t('notifications.ticketsFilters.searchingTickets')}
                    textLabel={t('notifications.ticketsFilters.selectOneOrMoreTicketModels2')}
                  />}
                <AutocompleteWithApi
                  onChange={(values) => setModelos(values)}
                  selectedValues={modelos ?? []}
                  setOpen={setOpenChamadoLegado}
                  options={[...new Set(legadoData as { id: string, nome: string }[])]
                    ?.map((legado) => (
                      { label: legado.nome, value: legado.id, }
                    )) ?? []}
                  loading={isLoadingLegado || isFetchingLegado}
                  textoVazio={t('notifications.ticketsFilters.noMatchingTickets')}
                  textoLoading={t('notifications.ticketsFilters.selectOneOrMoreTicketModels')}
                  textLabel={t('notifications.ticketsFilters.selectOneOrMoreTicketModels')}
                />
              </Stack>
            </>}
            {filtersToShow.hierarquia && <>
              <Label className='filtersTitle'>{t('notifications.ticketsFilters.byHierarchy')}</Label>
              <Divider variant='middle' />
              <Stack direction='row' spacing={2} width='100%'>
                <AutocompleteWithApi
                  onChange={(values) => setClientes(values)}
                  selectedValues={clientes ?? []}
                  setOpen={setOpenCliente}
                  options={(clientesData as { id: string, nome: string }[])
                    ?.map((cliente) => (
                      { label: cliente.nome, value: cliente.id, }
                    )) ?? []}
                  loading={isLoadingClientes || isFetchingClientes}
                  textoVazio={`${t('notifications.ticketsFilters.without')} ${hierarchyLabel.cliente} ${t('notifications.ticketsFilters.corresponding')}`}
                  textoLoading={t('notifications.ticketsFilters.searchingClients')}
                  textLabel={`${t('notifications.ticketsFilters.selectOne')} ${hierarchyLabel.cliente}`}
                />
                <AutocompleteWithApi
                  onChange={(values) => setLocais(values)}
                  selectedValues={locais ?? []}
                  setOpen={setOpenLocal}
                  options={[...new Set(locaisData as { id: string, nome: string }[])]
                    ?.map((local) => (
                      { label: local.nome, value: local.id }
                    )) ?? []}
                  loading={isLoadingLocais || isFetchingLocais}
                  textoVazio={`${t('notifications.ticketsFilters.without')} ${hierarchyLabel.local} ${t('notifications.ticketsFilters.corresponding')}`}
                  textoLoading={t('notifications.ticketsFilters.searchingLocations')}
                  textLabel={`${t('notifications.ticketsFilters.selectOne')} ${hierarchyLabel.local}`}
                />
              </Stack>
              <Stack direction='row' spacing={2} width='100%'>
                <AutocompleteWithApi
                  onChange={(values) => setConjuntos(values)}
                  selectedValues={conjuntos ?? []}
                  setOpen={setOpenConjunto}
                  options={[...new Set(conjuntosData as { id: string, nome: string }[])]
                    ?.map((conjunto) => (
                      { label: conjunto.nome, value: conjunto.id }
                    )) ?? []}
                  loading={isLoadingConjuntos || isFetchingConjuuntos}
                  textoVazio={`${t('notifications.ticketsFilters.without')} ${hierarchyLabel.conjunto} ${t('notifications.ticketsFilters.corresponding')}`}
                  textoLoading={t('notifications.ticketsFilters.searchingSets')}
                  textLabel={`${t('notifications.ticketsFilters.selectOne')} ${hierarchyLabel.conjunto}`}
                />
                <AutocompleteWithApi
                  onChange={(values) => setUnidades(values)}
                  selectedValues={unidades ?? []}
                  setOpen={setOpenUnidade}
                  options={[...new Set(unidadesData as { id: string, nome: string }[])]
                    ?.map((unidade) => (
                      { label: unidade.nome, value: unidade.id, }
                    )) ?? []}
                  loading={isLoadingUnidades || isFetchingUnidades}
                  textoVazio={`${t('notifications.ticketsFilters.without')} ${hierarchyLabel.unidade} ${t('notifications.ticketsFilters.corresponding')}`}
                  textoLoading={t('notifications.ticketsFilters.searchingUnits')}
                  textLabel={`${t('notifications.ticketsFilters.selectOne')} ${hierarchyLabel.unidade}`}
                />
              </Stack>
            </>}
          </Stack>
        </Accordion >
      </Stack>
    </Stack >
  );
}
